import React, { useState } from "react";
import {
  Row,
  Col,
  Tab, 
  Tabs,
} from 'react-bootstrap';
import Feedback from "./Feedback";
import Support from "./Support";
export default function FeedbackSupport() {
  const [key, setKey] = useState('Feedback');
  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Tabs
            defaultActiveKey="Feedback"
            id="uncontrolled-tab-example"
            className="customtabs mb-2"
            activeKey={key}
            onSelect={(k) => setKey(k)}
          >
            <Tab eventKey="Feedback" title="Feedback">
              <Feedback/>
            </Tab>
            <Tab eventKey="Support" title="Support">
              <Support/>
            </Tab>
          </Tabs>
        </Col>
      </Row>
    </React.Fragment>
  );
}
